import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Select, TextInput } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/ProductsService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import { getCompanyData } from 'store/data/dataSlice'
// import { packOptions, yesNoOptionsString } from 'utils/options'
import { Tabs, Upload } from 'components/Ui'
import { packOptions } from 'utils/options'
injectReducer('products', reducer)

const validationSchema = Yup.object().shape({
    customer: Yup.string().required('customer field is required'),
    sku: Yup.string().required('product field is required'),
    sku_descr1: Yup.string().required('description field is required'),
    pack_id: Yup.string().required('pack id field is required'),
    sku_width: Yup.string().required('width field is required'),
    sku_height: Yup.string().required('height field is required'),
    kit_flag: Yup.string().required('kit flag field is required'),
    barcode1: Yup.string().required('barcode1 field is required'),
    barcode2: Yup.string().nullable(),
    barcode3: Yup.string().nullable(),
    barcode4: Yup.string().nullable(),
    barcode5: Yup.string().nullable(),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { customersData } = useSelector(state => state.listData)
    const { view, record, loading } = useSelector(state => state.products.data)

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = id => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/maestro/products')

    const handleSubmit = data => {
        if (id) {
            updateApiRecord(id, data)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                    dispatch(getCompanyData())
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord(data)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    dispatch(getCompanyData())
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    if (loading && id) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Products</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">{id ? 'Update Product' : 'Add New Product'}</h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={values => {
                                handleSubmit(values)
                            }}
                        >
                            {({ values, touched, errors }) => (
                                <Form>
                                    <Tabs.Group version={1}>
                                        <Tabs.List>
                                            <Tabs>Product</Tabs>
                                            {/* {id && <Tabs>Additional Documents</Tabs>} */}
                                        </Tabs.List>
                                        <Tabs.Panels className="mt-4">
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                                    <Field name="customer">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={customersData}
                                                                label="Customer"
                                                                size="sm"
                                                                placeholder="Select"
                                                                name="customer"
                                                                className="md:col-span-2"
                                                                disabled
                                                                error={errors.customer && touched.customer}
                                                                message={errors.customer}
                                                                value={values?.customer}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="sku">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Product"
                                                                name="sku"
                                                                disabled
                                                                error={errors.sku && touched.sku}
                                                                message={errors.sku}
                                                                value={values?.sku}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="barcode1">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Barcode 1"
                                                                name="barcode1"
                                                                error={errors.barcode1 && touched.barcode1}
                                                                message={errors.barcode1}
                                                                value={values?.barcode1}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="barcode2">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Barcode 2"
                                                                name="barcode2"
                                                                error={errors.barcode2 && touched.barcode2}
                                                                message={errors.barcode2}
                                                                value={values?.barcode2}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="barcode3">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Barcode 3"
                                                                name="barcode3"
                                                                error={errors.barcode3 && touched.barcode3}
                                                                message={errors.barcode3}
                                                                value={values?.barcode3}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    {/* <Field name="barcode4">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Barcode 4"
                                                                name="barcode4"
                                                                error={errors.barcode4 && touched.barcode4}
                                                                message={errors.barcode4}
                                                                value={values?.barcode4}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="barcode5">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Barcode 5"
                                                                name="barcode5"
                                                                error={errors.barcode5 && touched.barcode5}
                                                                message={errors.barcode5}
                                                                value={values?.barcode5}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field> */}
                                                    {/* <Field name="pack_id">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={packOptions}
                                                                label="Pack ID"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="pack_id"
                                                                error={errors.pack_id && touched.pack_id}
                                                                message={errors.pack_id}
                                                                value={values?.pack_id}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field> */}
                                                    <Field name="pack_id">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Pack ID"
                                                                name="pack_id"
                                                                error={errors.pack_id && touched.pack_id}
                                                                message={errors.pack_id}
                                                                value={values?.pack_id}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="sku_descr1">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Description"
                                                                name="sku_descr1"
                                                                error={errors.sku_descr1 && touched.sku_descr1}
                                                                message={errors.sku_descr1}
                                                                value={values?.sku_descr1}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="sku_length">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Length"
                                                                name="sku_length"
                                                                error={errors.sku_length && touched.sku_length}
                                                                message={errors.sku_length}
                                                                value={values?.sku_length}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="sku_width">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Width"
                                                                name="sku_width"
                                                                error={errors.sku_width && touched.sku_width}
                                                                message={errors.sku_width}
                                                                value={values?.sku_width}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="sku_height">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Height"
                                                                name="sku_height"
                                                                error={errors.sku_height && touched.sku_height}
                                                                message={errors.sku_height}
                                                                value={values?.sku_height}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    <Field name="gross_weight">
                                                        {({ field, form }) => (
                                                            <TextInput
                                                                type="text"
                                                                className="md:col-span-2"
                                                                label="Weight"
                                                                name="gross_weight"
                                                                error={errors.gross_weight && touched.gross_weight}
                                                                message={errors.gross_weight}
                                                                value={values?.gross_weight}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field>
                                                    {/* <Field name="kit_flag">
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={yesNoOptionsString}
                                                                label="Kit Flag"
                                                                size="sm"
                                                                placeholder="Select"
                                                                className="md:col-span-2"
                                                                name="kit_flag"
                                                                error={errors.kit_flag && touched.kit_flag}
                                                                message={errors.kit_flag}
                                                                value={values?.kit_flag}
                                                                onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                            />
                                                        )}
                                                    </Field> */}
                                                </div>
                                            </Tabs.Panel>
                                            <Tabs.Panel>
                                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-5">
                                                    <div>
                                                        <Field name="file1">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file1 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi01 && (
                                                                    <a
                                                                        href={values?.hedi01 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 1</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file2">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file2 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi02 && (
                                                                    <a
                                                                        href={values?.hedi02 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 2</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file3">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file3 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi03 && (
                                                                    <a
                                                                        href={values?.hedi03 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 3</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file4">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file4 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi04 && (
                                                                    <a
                                                                        href={values?.hedi04 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 4</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        <Field name="file5">
                                                            {({ field, form }) => (
                                                                <Upload
                                                                    onFilesSelected={files =>
                                                                        form.setFieldValue(field.name, files[0])
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                        {values?.file5 ? null : (
                                                            <div className="mt-4 text-[blue]">
                                                                {values?.hedi05 && (
                                                                    <a
                                                                        href={values?.hedi05 || '#'}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        <u>Document - 5</u>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Tabs.Panel>
                                        </Tabs.Panels>
                                    </Tabs.Group>
                                    {values?.error_message && (
                                        <div className="mt-6 px-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                                            <h4 className="text-sm text-[red] font-medium text-blue-900 dark:text-blue-100">
                                                Error: {values?.error_message}
                                            </h4>
                                        </div>
                                    )}
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-[#F05540] border border-[#F05540] dark:text-[#F05540] dark:border-[#F05540]"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
